import { fetchJSON, fetchWithAuth } from "../util/fetch-utils";
export default class VelavuAPIBackends {
    //This method returns all of an organization's backends.
    getAllBackends() {
        return fetchJSON("/backends");
    }
    //This method returns a single backend by its unique ID.
    getSpecificBackend(backendID) {
        return fetchJSON(`/backends/${backendID}`);
    }
    //This method creates a new backend configuration.
    createNewBackend(params) {
        return fetchJSON("/backends", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method modifies the name, configuration, or certificates of a backend.
    modifyExistingBackend(backendID, params) {
        return fetchJSON(`/backends/${backendID}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method deletes an existing backend.
    deleteBackend(backendID) {
        return fetchWithAuth(`/backends/${backendID}`, {
            method: "DELETE",
        });
    }
    //This method configures a device to connect to the backend.
    addDevice(backendID, deviceID) {
        return fetchJSON(`/backends/${backendID}/device/${deviceID}`, {
            method: "PUT",
        });
    }
    //This method removes the configuration and disconnects a device from the backend.
    removeDevice(backendID, deviceID) {
        return fetchJSON(`/backends/${backendID}/device/${deviceID}`, {
            method: "DELETE",
        });
    }
}
//# sourceMappingURL=velavu-api-backends.js.map